import clsx from 'clsx';
import { forwardRef, type SelectHTMLAttributes } from 'react';

import styles from './StatusSelect.module.css';

import type { SelectOption } from './controls';
import type { StatusTone } from '../charts/chart-colors';

export interface StatusSelectProps extends Omit<
  SelectHTMLAttributes<HTMLSelectElement>,
  'children'
> {
  readonly options: readonly SelectOption[];
  /** Rendered as a leading empty option, e.g. "— Select —". */
  readonly placeholder?: string;
  /**
   * Colours the control itself so the state reads down a dense column without
   * spending a second cell on a badge.
   */
  readonly tone?: StatusTone;
}

/**
 * A select that carries its own state colour. Callers map a domain value to a
 * tone via the exported maps below, keeping domain codes out of the stylesheet.
 */
export const StatusSelect = forwardRef<HTMLSelectElement, StatusSelectProps>(function StatusSelect(
  { options, placeholder, tone = 'idle', className, ...rest },
  ref,
) {
  return (
    <select ref={ref} data-tone={tone} className={clsx(styles.stsel, className)} {...rest}>
      {placeholder !== undefined && <option value="">{placeholder}</option>}
      {options.map((option) => (
        <option key={option.value} value={option.value} disabled={option.disabled}>
          {option.label}
        </option>
      ))}
    </select>
  );
});
